'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCarousel = exports.CLASS_ACTIVE = exports.THUMBNAIL_SELECTOR = exports.PRODUCT_THUMBNAIL_COUNT = exports.PRODUCT_INITIAL_VARIANT = exports.THUMBNAIL_INDEX = exports.CAROUSEL_PROGRESS_INNER = exports.PRODUCT_VIDEO_SELECTOR = exports.PRODUCT_VIDEO_ID = exports.PRODUCT_THUMBNAIL_SELECTOR = exports.PRODUCT_IMAGE_SELECTOR = exports.PRODUCT_JSON_SELECTOR = exports.PRODUCT_TEMPLATE_SELECTOR = exports.CAROUSEL_NAVIGAITON_SELECTOR = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _Swatch = require('./../../objects/swatch/Swatch');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/07/06
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-product-carousel-container]';
var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-product-carousel]';
var CAROUSEL_NAVIGAITON_SELECTOR = exports.CAROUSEL_NAVIGAITON_SELECTOR = '[data-product-carousel-navigation]';
var PRODUCT_TEMPLATE_SELECTOR = exports.PRODUCT_TEMPLATE_SELECTOR = '[data-product-template]';
var PRODUCT_JSON_SELECTOR = exports.PRODUCT_JSON_SELECTOR = '[data-product-json]';
var PRODUCT_IMAGE_SELECTOR = exports.PRODUCT_IMAGE_SELECTOR = '[data-product-template-carousel-image]';
var PRODUCT_THUMBNAIL_SELECTOR = exports.PRODUCT_THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';
var PRODUCT_VIDEO_ID = exports.PRODUCT_VIDEO_ID = 'product-carousel-video';
var PRODUCT_VIDEO_SELECTOR = exports.PRODUCT_VIDEO_SELECTOR = '[data-product-carousel-video]';
var CAROUSEL_PROGRESS_INNER = exports.CAROUSEL_PROGRESS_INNER = '[data-product-carousel-progress]';

//Attrs
var THUMBNAIL_INDEX = exports.THUMBNAIL_INDEX = 'data-index';
var PRODUCT_INITIAL_VARIANT = exports.PRODUCT_INITIAL_VARIANT = 'data-initial-variant-id';
var PRODUCT_THUMBNAIL_COUNT = exports.PRODUCT_THUMBNAIL_COUNT = 'data-thumbnail-count';

var THUMBNAIL_SELECTOR = exports.THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';

var CLASS_ACTIVE = exports.CLASS_ACTIVE = 'is-active';

var ProductCarousel = exports.ProductCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(ProductCarousel, _CarouselSection);

  function ProductCarousel(container) {
    (0, _classCallCheck3.default)(this, ProductCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductCarousel.__proto__ || Object.getPrototypeOf(ProductCarousel)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.navigation = container.find(CAROUSEL_NAVIGAITON_SELECTOR);
    _this.productThumb = container.find(PRODUCT_THUMBNAIL_SELECTOR);
    _this.thumbCount = _this.productThumb.length;
    _this.progressBar = container.find(CAROUSEL_PROGRESS_INNER);

    //JSON Data
    _this.jsonElement = (0, _jquery2.default)(PRODUCT_TEMPLATE_SELECTOR).find(PRODUCT_THUMBNAIL_SELECTOR);

    _this.slick = _this.initCarousel(_this.carouselContainer);

    //Events
    (0, _jquery2.default)(document).on('click', THUMBNAIL_SELECTOR, function (e) {
      return _this.onThumbnailClick(e);
    });
    (0, _jquery2.default)(document).on(_Swatch.ON_VARIANT_CHANGE, function (e, variant) {
      return _this.onVariantChange(variant);
    });

    container.on('beforeChange', CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
      _this.goToThumb(nextSlide);
    });

    if (_this.thumbCount > 4) _this.initNavCarousel(); //Initialise navigation slick
    _this.initVariantImage(); //Initialise variant image
    container.on('beforeChange', CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
      _this.updateProgress(slick, currentSlide, nextSlide);
    });
    return _this;
  }

  (0, _createClass3.default)(ProductCarousel, [{
    key: 'initNavCarousel',
    value: function initNavCarousel() {
      this.navigationSlick = this.navigation.slick({
        mobileFirst: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        draggable: true,
        adaptiveHeight: false,
        swipeToSlide: true
      });
    }
  }, {
    key: 'initVariantImage',
    value: function initVariantImage() {
      //Set the thumb and main image on page load
      var initial = this.productThumb.attr(PRODUCT_INITIAL_VARIANT);
      var thumbTarget = (0, _jquery2.default)(PRODUCT_THUMBNAIL_SELECTOR + '[data-image-id="' + initial + '"]');
      var mainTarget = (0, _jquery2.default)(PRODUCT_IMAGE_SELECTOR + '[data-image-id="' + initial + '"]');

      if (!thumbTarget.length || !mainTarget.length) return;
      if (this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', parseInt(thumbTarget.attr(THUMBNAIL_INDEX)), false);
      this.slick.slick('slickGoTo', parseInt(mainTarget.attr(THUMBNAIL_INDEX)), false);
    }
  }, {
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        cssEase: 'linear',
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        swipe: true,
        responsive: [{
          breakpoint: 1100,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: false, arrows: true, infinite: true }
        }]
      };
    }

    //Thumbnail Navigation

  }, {
    key: 'onThumbnailClick',
    value: function onThumbnailClick(e) {
      var self = (0, _jquery2.default)(e.currentTarget);
      var index = self.attr('data-index');
      this.goToSlide(index);
    }
  }, {
    key: 'onVariantChange',
    value: function onVariantChange(variant) {
      if ((typeof variant === 'undefined' ? 'undefined' : (0, _typeof3.default)(variant)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) return;

      //Set our image, use the one for this variant, if not use default.
      if (!variant.featured_image) return;
      var imageId = variant.featured_image.id;
      var target = (0, _jquery2.default)(PRODUCT_THUMBNAIL_SELECTOR + '[data-image-id=' + imageId + ']');
      if (!target.length) return;
      if (this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', parseInt(target.attr(THUMBNAIL_INDEX)));
      target.trigger('click');
    }
  }, {
    key: 'goToSlide',
    value: function goToSlide(index) {
      this.carouselContainer.slick('slickGoTo', index);
      this.setActiveImage(index);
    }
  }, {
    key: 'goToThumb',
    value: function goToThumb(nextSlide) {
      if (this.thumbCount > 4) this.navigationSlick.slick('slickGoTo', nextSlide);
      this.setActiveImage(nextSlide);
    }
  }, {
    key: 'setActiveImage',
    value: function setActiveImage(index) {
      (0, _jquery2.default)(THUMBNAIL_SELECTOR).removeClass(CLASS_ACTIVE);
      (0, _jquery2.default)(THUMBNAIL_SELECTOR + '[data-index="' + index + '"]').addClass(CLASS_ACTIVE);
    }
  }, {
    key: 'onImageSlideChange',
    value: function onImageSlideChange(toSlide) {
      this.setActiveImage(toSlide);
    }
  }, {
    key: 'onThumbnailSlideChange',
    value: function onThumbnailSlideChange(toSlide) {
      this.carouselContainer.slick('slickGoTo', toSlide);
      this.setActiveImage(toSlide);
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(slick, currentSlide, nextSlide) {
      var calc = nextSlide / slick.slideCount * 100;
      calc = calc + 100 / slick.slideCount;
      this.progressBar.css('width', calc + '%');
    }
  }]);
  return ProductCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ProductCarousel);